module.exports = __webpack_public_path__ + "static/billsby-feature-tags-83476c4adca61aed50f424879f500c44.svg";